import { useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { api, ERROR_TEXT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Arrow } from "@/components/hm/Basics";
import { PENDING_NOTE_KEY } from "@/lib/welcomeNote";

export const WelcomeClarity = () => {
  const { user } = useAuth();
  const [note, setNote] = useState(() => localStorage.getItem(PENDING_NOTE_KEY) || "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const change = (v) => {
    setNote(v);
    setSaved(false);
    if (!user) v.trim() ? localStorage.setItem(PENDING_NOTE_KEY, v) : localStorage.removeItem(PENDING_NOTE_KEY);
  };
  const save = async () => {
    setSaving(true);
    try {
      await api.post("/modules/m1/complete", { note: note.trim() });
      localStorage.removeItem(PENDING_NOTE_KEY);
      setSaved(true);
      toast.success("Guardado en tu diario de claridad.");
    } catch { toast.error(ERROR_TEXT); } finally { setSaving(false); }
  };
  return (
    <section className="journal" style={{ marginTop: "3rem" }} data-testid="welcome-clarity">
      <span className="eyebrow">Tu momento de claridad</span>
      <label htmlFor="welcome-note" style={{ display: "block", margin: ".9rem 0 .4rem", fontWeight: 600, fontSize: 15 }}>¿Qué siento ahora mismo?</label>
      <textarea id="welcome-note" value={note} onChange={(e) => change(e.target.value)} maxLength={2000}
        placeholder="Basta con una palabra. Solo lo verás tú." data-testid="welcome-note-input" />
      <div className="journal-f">
        {user ? (
          <>
            <span className="text-faint" style={{ fontSize: 12.5 }}>{saved ? "Guardado en tu diario." : "Se guarda en tu diario de claridad."}</span>
            <button type="button" className="btn btn-primary btn-sm" onClick={save} disabled={saving || !note.trim()} data-testid="welcome-note-save">
              {saving ? "Guardando..." : "Guardar en mi diario"}
            </button>
          </>
        ) : (
          <>
            <span className="inline-flex items-center gap-1" style={{ fontSize: 12.5 }}><Lock size={12} /> Se guarda en este dispositivo hasta que crees tu cuenta</span>
            <Link to="/registro" className="btn btn-primary btn-sm" data-testid="welcome-note-register">Crear mi cuenta para guardarlo <Arrow /></Link>
          </>
        )}
      </div>
    </section>
  );
};
